import * as types from "../../constants";
import {
  createProperty as propertyCreateProperty,
  updateProperty as propertyUpdateProperty,
  fetchPropertiesQuery as propertyFetchProperties,
  fetchProperty as propertyFetchProperty,
  fetchPagedProperties as propertyPagedFetch,
  partialUpdateProperty as partialUpdateProp,
  getAccessibilityUnitTypes,
} from "../../services/propertyService";
import {
  fetchPropertyAccessibilityInfo as propertyFetchPropertyAccessibilityInfo,
  updatePropertyAccessibilityInfo as propertyUpdatePropertyAccessibilityInfo,
  createPropertyAccessibilityInfo as propertyCreatePropertyAccessibilityInfo
} from "../../services/propertyAccessibilityInfoService"
import {
  fetchPropertyFreeTextInfos as propertyFetchPropertyFreeTextInfos,
  createPropertyFreeTextInfos as propertyCreatePropertyFreeTextInfos,
  updatePropertyFreeTextInfos as propertyUpdatePropertyFreeTextInfos,
  deletePropertyFreeTextInfos as propertyDeletePropertyFreeTextInfos
} from "../../services/propertyFreeTextInfosService"
import { PropertyRequest } from "../../models/Property";
import { DispatchOf } from "../utils";
import { PropertyActions } from "../reducers/propertyReducer";
import {ErrorsActions} from "../reducers/toastsReducer";
import {PropertyFreeTextInfosRequest} from "../../models/PropertyFreeTextInfos";
import {PropertyAccessibilityInfosRequest} from "../../models/PropertyAccessibilityInfo";
import {CREATE_PROPERTY_ACCESSIBILITY_INFOS} from "../../constants";

export function fetchProperty(id: any, token: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyFetchProperty(id, token)
      .then(response => {
        dispatch({
          type: types.FETCH_PROPERTY,
          property: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchProperties(token: string, query = {}) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyFetchProperties(token, query)
      .then((response) => {
        dispatch({
          type: types.FETCH_PROPERTIES,
          properties: response.data.results,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchPagedProperties(token: string, page: number, search: string, filterBy: any, removeFirst: boolean = true) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    dispatch({
      type: types.LOADING_PROPERTIES,
      payload: true
    });
    return propertyPagedFetch(token, page, search, filterBy, removeFirst)
      .then(response => {
        dispatch({
          type: types.FETCH_PROPERTIES,
          properties: response.data.results,
        });
        dispatch({
          type: types.SET_PROPERTY_COUNT,
          count: response.data.count
        });
        dispatch({
          type: types.LOADING_PROPERTIES,
          payload: false
        });

      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function createProperty(data: PropertyRequest | any, token: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    try {
      const response = await propertyCreateProperty(data, token);
      dispatch({
        type: types.PROPERTY_CREATE,
        property: response.data,
      });
      return response;
    } catch (error) {
      dispatch({
        type: types.ADD_TOAST,
        payload: error
      });
      throw error;
    }
  };
}

export function updateProperty(data: PropertyRequest | any, token: string, id: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {

    return propertyUpdateProperty(data, token, id)
      .then((response: any) => {
        dispatch({
          type: types.PROPERTY_UPDATE,
          property: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function partialUpdateProperty(data: Partial<PropertyRequest>, token: string, id: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {

    return partialUpdateProp(data, token, id)
      .then((response: any) => {
        dispatch({
          type: types.PARTIAL_PROPERTY_UPDATE,
          property: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function accessibilityUnitTypes(id: string, token: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return getAccessibilityUnitTypes(id, token)
      .then((response: any) => {
        dispatch({
          type: types.GET_ACCESSIBILITY_UNIT_TYPES,
          property: response.data.accessibility_unit_types,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function clearProperties() {
  return ({
    type: types.CLEAR_PROPERTIES,
  })
}

export function clearTotalAccessibilityProgressBar() {
  return ({
    type: types.CLEAR_TOTAL_ACCESSIBILITY_PROGRESS_BAR,
  })
}

export function totalAccessibilityProgressBar(token: string, companyId?: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    const results = {completed: 0, notCompleted: 0}

    let completedQuery: any = {
      accessibility_progress_bar_completion_percent: '1.0',
      limit: 1
    }
    let notCompletedQuery: any = {
      limit: 1
    }
    if (companyId) {
      completedQuery.company = companyId
      notCompletedQuery.company = companyId
    }
    propertyFetchProperties(token, completedQuery)
      .then((response) => {
        results.completed = response.data.count;
        propertyFetchProperties(token, notCompletedQuery)
          .then((response) => {
            results.notCompleted = response.data.count - results.completed
            dispatch({
              type: types.FETCH_TOTAL_ACCESSIBILITY_PROGRESS_BAR,
              payload: results,
            });
          }
        ).catch((error) => {
          dispatch({
            type: types.ADD_TOAST,
            payload: error
          })
        })
      }
    ).catch((error) => {
      dispatch({
        type: types.ADD_TOAST,
        payload: error
      })
    })
  };
}

export function fetchPropertyAccessibilityInfo(token: string, property: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyFetchPropertyAccessibilityInfo(token, property)
      .then((response) => {
        dispatch({
          type: types.FETCH_PROPERTY_ACCESSIBILITY_INFOS,
          payload: response.data.results,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function createPropertyAccessibilityInfo(data: PropertyAccessibilityInfosRequest, token: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyCreatePropertyAccessibilityInfo(data, token)
      .then((response) => {
        dispatch({
          type: types.CREATE_PROPERTY_ACCESSIBILITY_INFOS,
          payload: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function updatePropertyAccessibilityInfo(data: PropertyAccessibilityInfosRequest, token: string, id: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyUpdatePropertyAccessibilityInfo(data, token, id)
      .then((response) => {
        dispatch({
          type: types.UPDATE_PROPERTY_ACCESSIBILITY_INFOS,
          payload: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchPropertyFreeTextInfos(token: string, property: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyFetchPropertyFreeTextInfos(token, property)
      .then((response) => {
        dispatch({
          type: types.FETCH_PROPERTY_FREE_TEXT_INFOS,
          payload: response.data.results,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function createPropertyFreeTextInfos(data: PropertyFreeTextInfosRequest, token: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyCreatePropertyFreeTextInfos(data, token)
      .then((response) => {
        dispatch({
          type: types.CREATE_PROPERTY_FREE_TEXT_INFOS,
          payload: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function updatePropertyFreeTextInfos(data: PropertyFreeTextInfosRequest, token: string, freeTextId: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyUpdatePropertyFreeTextInfos(data, token, freeTextId)
      .then((response) => {
        dispatch({
          type: types.UPDATE_PROPERTY_FREE_TEXT_INFOS,
          payload: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}


export function deletePropertyFreeTextInfos(id: string, token: string) {
  return async (dispatch: DispatchOf<PropertyActions> & DispatchOf<ErrorsActions>) => {
    return propertyDeletePropertyFreeTextInfos(id, token)
      .then(() => {
        dispatch({
          type: types.DELETE_PROPERTY_FREE_TEXT_INFOS,
          payload: id,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

